(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["cart-template"]) return;
  try {
    

$(document).ready(function(){
  $('.cart-page table tbody tr').each(function(){
    var href = $(this).find('.cart__meta a').attr('href');
    var new_href = href.substring(0, href.indexOf("?"));
    $(this).find('.cart__meta a').attr('href',new_href);
  });
});







  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
$(window).load(function(){
$.ajax({
url:'https://phone-accessories-jood.myshopify.com/cart',
success: function(data) {
var a = $(data).find('#CartCount span.spncountCart').text();
console.log(a);
if(data != ''){
//console.log('hi');
$('.cart.robotobold a').find('.cartCountCustom .spncountCart').text('');
$('.cart.robotobold a').find('.cartCountCustom .spncountCart').text(a);
}

}
});
});

  } catch(e) { console.error(e); }
})();

})();
